const ArrowLeft_Icon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_451_5986)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.90619 2.87051L3.82519 5.91652L13.0192 5.95852C13.1598 5.95904 13.2989 5.98727 13.4286 6.04159C13.5583 6.09591 13.676 6.17525 13.775 6.27509C13.874 6.37493 13.9523 6.4933 14.0056 6.62343C14.0588 6.75357 14.0858 6.89292 14.0852 7.03352C14.0845 7.17416 14.0562 7.3133 14.0018 7.44299C13.9473 7.57268 13.8679 7.69038 13.768 7.78937C13.6681 7.88835 13.5496 7.96669 13.4194 8.01991C13.2892 8.07312 13.1498 8.10017 13.0092 8.09952L3.81719 8.05752L6.85719 11.1335C6.9563 11.2334 7.03477 11.3518 7.08812 11.482C7.14146 11.6121 7.16863 11.7516 7.16807 11.8923C7.16751 12.033 7.13924 12.1722 7.08487 12.3019C7.0305 12.4317 6.95109 12.5495 6.85119 12.6485C6.64926 12.8483 6.3763 12.9598 6.09224 12.9585C5.80818 12.9572 5.53626 12.8432 5.33619 12.6415L0.336187 7.59252C0.17269 7.42635 0.0818934 7.20205 0.0837687 6.96895C0.0856441 6.73584 0.180038 6.51303 0.346187 6.34952L5.39919 1.34951C5.60094 1.14978 5.87374 1.03832 6.15764 1.03963C6.44153 1.04095 6.71329 1.15492 6.91319 1.35651C7.11292 1.55827 7.22438 1.83107 7.22307 2.11496C7.22176 2.39886 7.10778 2.67062 6.90619 2.87051Z"
          fill="#4CB596"
        />
      </g>
      <defs>
        <clipPath id="clip0_451_5986">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ArrowLeft_Icon;
